import { SNF_API_BASE_URL } from '../../../../constants/environment/environment';
import { JsonResponseParser } from '../../parsers/json-response.parser';
import { HttpRemoteCall } from '../http-remote-call';

export class SnfHttpRemoteCall extends HttpRemoteCall {
  /**
   * @inheritdoc
   */
  baseUrl = SNF_API_BASE_URL;

  constructor(responseParser) {
    super(responseParser || new JsonResponseParser());
  }
}
